
  export const REPORTES_RECEIVED = "REPORTES_RECEIVED";
  export const SET_REPORTE = "SET_REPORTE";
  export const CREATE_REPORTE = "CREATE_REPORTE";
  export const SET_PROPERTY_REPORTE = "SET_PROPERTY_REPORTE";
  export const SET_GENERANDO_PDF = "SET_GENERANDO_PDF";
